import React, { useState, useEffect } from "react";
import { PricesContext } from "src/shared";
import { useLocation } from "react-router-dom";
import { TablePrices } from "src/features/Table";
import { AddPriceButton } from "src/widgets/Button";
import FilterPrices from "../../../shared/ui/Tables/FilterPrices";
import { Space, Button } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

export default function TablePricesPage({
  websocket,
  token,
  initialData,
  priceTypesData,
  manufacturersData,
  nomenclatureData,
  categoriesData,
  unitsData,
  params,
  setPricesData,
  countData,
}) {
  const [data, setData] = useState(initialData);
  const [filtersOpen, setFiltersOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setData(initialData);
    }
  }, [initialData]);
  const { pathname } = useLocation();
  return (
    <PricesContext.Provider
      value={{
        token,
        params,
        pathname,
        websocket,
        data,
        priceTypesData,
        manufacturersData,
        nomenclatureData,
        categoriesData,
        unitsData,
        setPricesData,
        countData,
      }}>
      <Space direction="vertical" style={{ width: "100%", marginBottom: 10 }}>
        <Space style={{ alignItems: "center" }}>
          <AddPriceButton />
          <Button
            type="text"
            icon={filtersOpen ? <DownOutlined /> : <RightOutlined />}
            onClick={() => setFiltersOpen((prev) => !prev)}
          >
            Фильтры поиска установки цен
          </Button>
        </Space>
        <FilterPrices isOpen={filtersOpen} />
      </Space>

      <TablePrices />
    </PricesContext.Provider>
  );
}
